import React, { useEffect, useState} from 'react'
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { Button as ModalButton } from '@material-ui/core';
import { hideNavbar,logOut } from '../store/actions/CommonAction';
import { useDispatch, useSelector} from 'react-redux';
import { getProfileData, updateLogo } from '../store/actions/CommonAction';
import loader from '../assets/loader.gif'
import accountcircle from '../assets/account_circle.svg'
import { ToastContainer, toast } from 'react-toastify';

import { TimeoutLogic } from "../utils/TimeoutLogic";

const Profile = (props) => {
    const history = useHistory();
    const [showModal,setShowModal] = useState(false);
    const [showGuideModal,setShowGuideModal] = useState(false);
    const [file, setFile] = useState();
    const dispatch = useDispatch();

    const clientId = useSelector(state => state.common.clientId)
    const clientEmail = useSelector(state => state.common.email)
    const clientMobile = useSelector(state => state.common.mobile)
    const profileData = useSelector(state => state.common.profileData)
    const getProductTheme = useSelector(state => state.common.getProductTheme)
    const avatarImage = (profileData.logo == undefined || profileData.logo == null) ?
    accountcircle : profileData.logo;
    const callAPI = async () => {
        try {
          await dispatch(getProfileData(clientId))
        } catch (error) {
          console.error(error)
        }
      }
    
    // const applyTheme = ()=>{
    //     //document.getElementById("menuBar").style.setProperty('background-color', getProductTheme.theme, 'important');
          
    //       const consentCard = document.getElementsByClassName("consent-card");
    //       for (let i = 0; i < consentCard.length; i++) {
    //         consentCard[i].style.setProperty('border-top','4px solid '+getProductTheme.theme, 'important')
    //       }
    
    //       const cardHeader = document.getElementsByClassName("card-header");
    //       for (let i = 0; i < cardHeader.length; i++) {
    //         cardHeader[i].style.setProperty('color',getProductTheme.theme, 'important')
    //       }
       
    //       const dashboardCard = document.getElementsByClassName("dashboard-card");
    //       for (let i = 0; i < dashboardCard.length; i++) {
    //         dashboardCard[i].style.setProperty('border-top','4px solid '+getProductTheme.theme, 'important')
    //       }
  
    
    //       const th = document.getElementsByTagName("th");
    //       for (let i = 0; i < th.length; i++) {
    //         th[i].style.setProperty('color', getProductTheme.theme, 'important')
    //       }
    
    // }

    // useEffect(() => { callAPI();
    //     applyTheme();
    // }, [])


    const signOut = async() =>{
        await dispatch(logOut())
        await dispatch(hideNavbar(false))
        localStorage.clear();
        history.push('/')
        window.location.reload();
    }

    const deleteAlert = async()=>{
        setShowModal(!showModal)
        // await dispatch(hideNavbar())
    }

    const deleteAcc = async() =>{
        // await dispatch(hideNavbar())
        localStorage.clear();
        history.push('/')
        window.location.reload();

        // await axios.delete(config.LOG_OUT).then(
        //     response =>{
        //         console.log("resp in profile, ",JSON.stringify(response.data));
        //         history.push('/')

        //     }).catch(error =>{
        //         console.log("something went wrong ERROR  " ,JSON.stringify(error) )
        //         history.push('/home')
        //     })
    }

    // useEffect(() => {
    //     try{
    //         let resp =  makeAPICall("https://apisetu.gov.in/gstn/v1/taxpayers/27AAACR5055K1Z7","GET", {},
    //          {"X-APISETU-CLIENTID":"com.ril",
    //          "X-APISETU-APIKEY":"clm6rVOJ0msm5aROsVfFNaJBymzMoB7Q"
    //         })
    //         console.log("response   in profile, ",JSON.stringify(resp))
    //     }catch(error){
    //         console.log("something went wrong")
    //     }
    // }, [])
     
    const setLogo = async (value) =>{

       // alert("in set logo");

        let base64String = "";

        document.getElementById("loaderImg").style.display = "block";
        
       // alert(JSON.stringify(value));
        // document.getElementById("logo-area").style.display = "block";
        // setFile(URL.createObjectURL(value));

        let reader = new FileReader();

        reader.onload = async function(){
            base64String = reader.result;
           // console.log("base64String: "+base64String);

            let request = {
                "clientId":clientId,
                "base64Image":base64String 
            }
    
    
            await dispatch(updateLogo(request));

            document.getElementById("loaderImg").style.display = "none";
        }

        reader.readAsDataURL(value);


       
    }

    function handleFileChange(event) {
        const file = event.target.files[0];
        if (file) {
            const fileType = file.type;
            const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];
    
            if (validImageTypes.includes(fileType)) {
                setLogo(event.target.files[0]);
            } else {
                alert('Please select a valid image file (JPG, PNG, GIF).');
                event.target.value = '';
            }
        }
    }

    useEffect(()=>{
        if(!sessionStorage.getItem('sessionId')){
            toast.error(`Your Session has Expired: Please login again`);
            window.location.href = '/login';
        }
    }, [])
   //console.log('hi');

    return (
        
        <div className="container">     
          <div className="row align-items-center vh-100">
            <div className="col-md-5 col-md-offset-3">
              <div className='login-box' style={{width: '700px' , padding: '0px', marginTop:'8%'}}>
                {profileData &&
                    <div class="row consent-card profile-card" style={{padding:'50px'}}>
                        <div className="col-sm-4 text-center" style={{borderRight:'1px solid #ccc'}}>
                            <div className="logo-area" style={{padding:'50px'}} >
                                <img src={loader} id="loaderImg"  style={{position:'absolute', marginLeft:'8%', height:'100px', backgroundColor:'rgb(255 255 255 / 0%)', display:'none'}}></img>
                                <img src={avatarImage} class="img-thumbnail" alt="Logo"></img>
                            </div>
                            <div className="logo-update-area" >
                                        <h6><b>Choose a Logo</b></h6>
                                        <input type="file" className="form-control"
                                        onChange={(event) => {
                                            handleFileChange(event);
                                            
                                        }} 
                                        //onChange={(event)=> setLogo(event.target.files[0])}
                                        accept="image/png, image/jpeg" style={{fontSize:'11px', border:'1px solid #ccc', borderRadius:'5px', paddingLeft:'5px'}}></input>
                                        
                            </div>
                            <p className="link-primary" onClick={()=>setShowGuideModal(!showGuideModal)} style={{fontSize:'11px'}}>Logo Customization Guidelines</p>
                        </div>
                        <div className="col-sm-8" >
                        {/* <form> */}
                            {/* <h3>Log Out</h3> */}
                            {/* <h4 className="p-3" style={{alignSelf:'center',textAlign:'center'}}>My Profile </h4> */}
                            <tr>
                                <th>
                                    <h6 className="p-3" style={{alignSelf:'left',textAlign:'left', fontSize:'14px'}}><b>Client Id:</b> </h6>
                                </th>
                                <td>
                                    <h6 className="p-3" style={{alignSelf:'left',textAlign:'left', fontSize:'14px'}}>{clientId} </h6>
                                </td>
                            </tr>

                            <tr>
                                <th>
                                    <h6 className="p-3" style={{alignSelf:'left',textAlign:'left', fontSize:'14px'}}><b>App Name:</b> </h6>
                                </th>
                                <td>
                                    <h6 className="p-3" style={{alignSelf:'left',textAlign:'left', fontSize:'14px'}}>{profileData.appName} </h6>
                                </td>
                            </tr>

                            <tr>
                                <th>
                                    <h6 className="p-3" style={{alignSelf:'left',textAlign:'left', fontSize:'14px'}}><b>SPOC Name:</b> </h6>
                                </th>
                                <td>
                                    <h6 className="p-3" style={{alignSelf:'left',textAlign:'left', fontSize:'14px'}}>{profileData.spoc}</h6>
                                </td>
                            </tr>

                            <tr>
                                <th>
                                    <h6 className="p-3" style={{alignSelf:'left',textAlign:'left', fontSize:'14px'}}><b>SPOC Email:</b> </h6>
                                </th>
                                <td>
                                    <h6 className="p-3" style={{alignSelf:'left',textAlign:'left', fontSize:'14px'}}>{profileData.email} </h6>
                                </td>
                            </tr>

                            <tr>
                                <th>
                                    <h6 className="p-3" style={{alignSelf:'left',textAlign:'left', fontSize:'14px'}}><b>SPOC Mobile:</b> </h6>
                                </th>
                                <td>
                                    <h6 className="p-3" style={{alignSelf:'left',textAlign:'left', fontSize:'14px'}}>{profileData.mobile} </h6>
                                </td>
                            </tr>
                        </div>
                        
                            <Modal show={showModal}>
                                <Modal.Header >
                                    <Modal.Title>Delete account !!</Modal.Title>
                                </Modal.Header>

                                <Modal.Body>
                                            <label className="pr-2">Are you sure you want to delete your account? if you proceed it will delete all your created and published campaigns.</label>                        
                                </Modal.Body>

                                <Modal.Footer>
                                    <ModalButton variant="secondary mr-2" onClick={deleteAlert}>Close</ModalButton>
                                    <ModalButton  color="primary"  onClick={deleteAcc}>Proceed</ModalButton>
                                </Modal.Footer>
                        </Modal>   

                        <Modal size='L' show={showGuideModal}>
                                <Modal.Header style={{marginTop: "10px !important"}} >
                                    <Modal.Title>Logo Customization Guidelines</Modal.Title>
                                </Modal.Header>

                                <Modal.Body>
                                    <ol>
                                        <li><b>File format:</b> Use either JPEG or PNG format for your logo.</li>

                                        <li><b>Image quality:</b> Ensure the logo is of high quality with clear details, 
                                            considering the smaller rendered size. Aim for sharp edges and legibility.</li>

                                        <li><b>Size and dimensions:</b> Resize your logo to 169 × 68 pixels for the rendered size while 
                                            maintaining the original aspect ratio of 169∶68.</li>

                                        <li><b>Background transparency:</b> If your logo needs to have a transparent background, 
                                            save it as a PNG file with transparency enabled.</li>

                                        <li><b>File size:</b> Optimize the image to keep the file size below 28.5 kB while maintaining 
                                            good image quality. You can achieve this by reducing unnecessary details, using appropriate compression, 
                                            or adjusting the image format settings.</li>
                                    </ol>    
                                </Modal.Body>

                                <Modal.Footer>
                                    <ModalButton onClick={()=>setShowGuideModal(!showGuideModal)}  variant="secondary mr-2">Close</ModalButton>
                                </Modal.Footer>
                        </Modal>   


                        {/* </form> */}


                        <TimeoutLogic />
                    </div>
                }
              </div>
            </div>
          </div>
          <ToastContainer></ToastContainer>
        </div>
        
    );
}

export default Profile;
